import * as React from 'react'
import { format } from 'date-fns'
import moment from 'moment-timezone'
import { CellRendererProps, SYSTEM_DATE_KEYS, SYSTEM_DATETIME_KEYS } from './types'

const OFFSET_SUFFIX_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i

function formatDateTimeValue(value: string, timeZone?: string): string | null {
  const zone = timeZone && moment.tz.zone(timeZone) ? timeZone : null
  const parsed = OFFSET_SUFFIX_PATTERN.test(value)
    ? moment.parseZone(value)
    : zone
      ? moment.tz(value, zone)
      : moment(value)

  if (!parsed.isValid()) {
    return null
  }

  return (zone ? parsed.tz(zone) : parsed).format('DD-MM-YYYY HH:mm')
}

export function formatDateCellValue(value: string, columnKey: string, timeZone?: string): string {
  if (SYSTEM_DATETIME_KEYS.includes(columnKey)) {
    const formattedDateTime = formatDateTimeValue(value, timeZone)
    if (formattedDateTime) {
      return formattedDateTime
    }
  }

  const date = new Date(value)
  if (isNaN(date.getTime())) {
    return value
  }

  const dateFormat = SYSTEM_DATETIME_KEYS.includes(columnKey)
    ? 'dd-MM-yyyy HH:mm'
    : 'dd-MM-yyyy'

  return format(date, dateFormat)
}

export function DateCell({ value, column, timeZone }: CellRendererProps): React.ReactNode {
  if (value == null || value === '') {
    return null
  }

  return <span className="text-nowrap">{formatDateCellValue(String(value), column.key, timeZone)}</span>
}

export function isDateColumn(columnType: string, columnKey: string): boolean {
  return (
    columnType === 'Projects::Columns::Date' ||
    (columnType === 'Projects::Columns::System' && SYSTEM_DATE_KEYS.includes(columnKey))
  )
}
